module.exports = __webpack_public_path__ + "static/media/bug.19ff1492.svg";